export default "__VITE_ASSET__DRGlstCX__"